module.exports = __webpack_public_path__ + "img/ic_icon_cvu_dni1.8a6c7904.png";